import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, Event } from "@angular/router";
import { Subscription } from 'rxjs';

import { AppService } from '@app/services/app/app.service';
import { ProjectsService } from '@app/services/app/projects.service';
import { ProjectsFormsService} from '@app/services/app/projects-forms.service';

import { TitleService } from '@core/services/title.service';

import * as Objects from '@core/objects';
import { FieldSubmissionValueInterface } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';


import { User } from '@core/objects/user';
import { Request } from '@core/objects/request';

@Component({
    selector: 'project-details-forms-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProjectDetailsFormsMainComponent implements OnInit, OnDestroy {
    private readonly FORMS_FEATURE_PLUGIN = "custom-forms";

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;

    public status: number = 0;
    public project: Request = null;
    public accessForms: boolean = false;
    public user: User;

    // leave guard management
    public leavingModal: boolean = false;
    public urlTo: string = '';
    public allowLeave: boolean = false;
    public changesPending: boolean = false;


    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];

    protected subscriptor: Subscription;
    protected appSubscriptor: Subscription;
    protected changesSubscriptor: Subscription;
    protected routerSubscriber: Subscription;

    constructor(
        private appSrv: AppService,
        private projectsSrv: ProjectsService,
        private projectFormsSrv: ProjectsFormsService,
        private title: TitleService,
        private router: Router
    ) { }

    // when website is realoaded
    @HostListener('window:beforeunload', ['$event'])
    onFormFillLeave(event: any): void {
        if(this.changesPending){
            event.preventDefault(); 
            event.returnValue = false;
        }
    }

    ngOnInit() {
        this.title.set("Forms - Project Details - Projects");

        this.appSubscriptor = this.appSrv.getSession().subscribe(session => {
            this.user = session.current.user;
            this.accessForms = session?.options?.plugins?.some((pa) => pa == this.FORMS_FEATURE_PLUGIN);
            this.loadProjectForms();
        });

        // get request
        this.subscriptor = this.projectsSrv.selectProject().subscribe((project: Request) => {
            if (project == null) return;

            this.setProject(project);
        });

        this.changesSubscriptor = this.projectFormsSrv.selectFormFieldsPendingValues().subscribe((pending: boolean) => {
            this.changesPending = pending;
        });

        this.routerSubscriber = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                if(this.router.url != event.url){
                    this.leavingModal = true;
                    this.urlTo = event.url;
                }
            }
        })

    }

    ngOnDestroy() {
        this.leavingModal = false;
        this.appSubscriptor.unsubscribe();
        this.subscriptor.unsubscribe();
        this.changesSubscriptor.unsubscribe();

        this.projectFormsSrv.cleanFormFieldValues();
    }

    onDiscard() : void {
        this.leavingModal = false;
        this.allowLeave = true;
        this.router.navigateByUrl(this.urlTo);
    }

    onStay() : void{
        this.leavingModal = false;
        this.allowLeave = false;

    }

    protected setProject(project: Request) {
        this.updateBreadcrumbs(project);
        this.project = project;
        this.loadProjectForms();
        this.title.set("Forms - Project " + this.project.id);

    }

    protected updateBreadcrumbs(project: Objects.Request) {
        this.breadcrumbs[0].link = '/projects/' + project.id;
        this.breadcrumbs[0].title = 'Project <small>(#' + project.id + ')</small>';
    }

    protected loadProjectForms(): void {
        if (this.accessForms && this.project && this.project.id ){
            this.projectFormsSrv.loadForms(this.project.id);
        }
    }

}
